<template>
  <div
    class="  px-10 mt-7">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-row>
            <v-col cols="12" md="4">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Mitra Warung"  
                          :src="require('@/assets/icon/life.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #232323;" class="fs-20 font-weight-medium mb-1">Life Insurance</v-list-item-title>

                        <v-list-item-subtitle class="fs-16 font-weight-medium color-ligth-blue">Unlimited protection</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Mitra Warung"  
                          :src="require('@/assets/icon/shop.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #232323;" class="fs-20 font-weight-medium mb-1">Shopping</v-list-item-title>

                        <v-list-item-subtitle class="fs-16 color-light-blue">Buy. Think. Grow.</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>


            <v-col cols="12" md="4">
              <v-card
                flat
                class="pa-5 border-radius-card">
                <div>
                  <v-list
                    subheader
                    two-line
                    class="pb-0"
                  >
                    <v-list-item class="px-0"
                    >
                      <v-list-item-avatar class="my-1" size="65">
                        <v-img
                          contain
                          alt="Mitra Warung"  
                          :src="require('@/assets/icon/safety.png')"
                          class="">
                          <template v-slot:placeholder>
                            <v-row
                              class=" "
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="30"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title style="color: #232323;" class="fs-20 font-weight-medium mb-1">Safety</v-list-item-title>

                        <v-list-item-subtitle class="fs-16 font-weight-medium color-light-blue">We are your allies</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="fs-22 mb-5 color-dark-blue font-weight-medium">
                Bank Services List              
              </div>

              <v-card
                flat
                class="pa-5 py-0 mb-6 border-radius-card"
                v-for="(item, i) in bank"
                :key="i">
                <v-row class="align-center">
                  <v-col cols="12" md="4">
                    <div class="d-flex align-center">
                      <div class="mr-4">
                        <v-avatar class="my-1" size="55" tile>
                          <v-img
                            contain
                            alt="Mitra Warung"  
                            :src="item.image_url"
                            class="">
                            <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>
                      <div>
                        <div>
                          <div style="color: #232323;" class="fs-16 font-weight-medium">{{ item.title }}</div>
    
                          <div class="color-light-blue fs-15">It is a long established </div>
                        </div>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="2">
                    <div>
                      <div style="color: #232323;" class="fs-16 font-weight-medium">Lorem Ipsum</div>

                      <div class="color-light-blue fs-15">Many publishing</div>
                    </div>
                  </v-col>

                  <v-col cols="2">
                    <div>
                      <div style="color: #232323;" class="fs-16 font-weight-medium">Lorem Ipsum</div>

                      <div class="color-light-blue fs-15">Many publishing</div>
                    </div>
                  </v-col>

                  <v-col cols="2">
                    <div>
                      <div style="color: #232323;" class="fs-16 font-weight-medium">Lorem Ipsum</div>

                      <div class="color-light-blue fs-15">Many publishing</div>
                    </div>
                  </v-col>

                  <v-col cols="2">
                    <v-tooltip 
                      top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          rounded
                          v-bind="attrs"
                          v-on="on"
                          elevation="0"
                          color="#123288"
                          height="35"
                          width="150"
                          class="text-capitalize ma-2"
                        >
                          View Details
                        </v-btn>
                      </template>

                      <span>View Details</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>


        </section>
      </v-flex>
    </v-layout>
  </div>
</template>


<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data() {
      return {
        bank: [
          {
            image_url: require('@/assets/icon/loans.png'),
            title: 'Business loans'
          },
          {
            image_url: require('@/assets/icon/corporate.png'),
            title: 'Checking accounts'
          },
          {
            image_url: require('@/assets/icon/business.png'),
            title: 'Savings accounts'
          },
          {
            image_url: require('@/assets/icon/personal.png'),
            title: 'Debit and credit cards'
          },
          {
            image_url: require('@/assets/icon/totalSaving.png'),
            title: 'Business loans'
          }
        ],
        process: {
          load: true
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      company () {
        return this.$store.state.company
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r+93}, ${g+120}, ${b+12})`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      },

      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },


      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    components: {
      
    },

    watch: {

    },
    mounted () {
      setTimeout(() => {
        this.process.load = false
      }, 1000)
    },
    methods: {
      
    }
  }
</script>

<style>
  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;

    /* background-color: #718EBF; */
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  }


  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
</style>